import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import { updateShipments, findPurchaseOrder } from '../../redux/actions/purchaseOrders';

import UpdateShipmentModal from './UpdateShipmentModal';
import AddShipmentModal from './AddShipmentModal';
import DeleteShipmentModal from './DeleteShipmentModal';


const UpdateShipments = ({ payload, sendUpdateShipments, loadPurchaseOrder, purchaseOrders }) => {

  const { id } = useParams();
  const [shipments, setShipments] = useState(null);
  const [showAddShipmentModal, setShowAddShipmentModal] = useState(false);
  const [showUpdateShipmentModal, setShowUpdateShipmentModal] = useState(false);
  const [showDeleteShipmentModal, setShowDeleteShipmentModal] = useState(false);

  const [activeShipment, setActiveShipment] = useState(null);

  useEffect(() => {
    loadPurchaseOrder(payload, id);
  }, []);

  useEffect(() => {
    if(purchaseOrders.activePurchaseOrder && purchaseOrders.status === 'success') {
      setShipments(purchaseOrders.activePurchaseOrder.shipments.filter(n => n) || []);
    }
  }, [purchaseOrders]);

  const addShipment = () => {
    setShowAddShipmentModal(true);
  }

  const updateDialog = (shipmentId) => {
    setActiveShipment(shipments.find(shipment => shipment.id === shipmentId));
    setShowUpdateShipmentModal(true);
  }

  const deleteDialog = (shipmentId) => {
    setActiveShipment(shipments.find(shipment => shipment.id === shipmentId));
    setShowDeleteShipmentModal(true);
  }

  const postUpdate = () => {
    sendUpdateShipments(payload, purchaseOrder.id, shipmentsJson());
    setShowShipmentsModal(false);
  }

  if(!purchaseOrders.activePurchaseOrder) {
    return(
      <>
        <PageHeader stripeBackground='#fbe194' helpLink="ecwid/update-purchase-order-shipments-2/" />

        <div className="settings-page cf">
          <div className="settings-page__header">
            <div className="named-area">
              <div className="named-area__header">
                <div className="named-area__titles">
                  <div className="named-area__title">Purchase Order Shipments</div>
                </div>
                <div className="named-area__description">
                  <p>Manage shipment information for this purchase order.</p>
                  <p>This information will be included in purchase order PDFs on a separate shipping page under the original purchase order.</p>
                </div>
              </div>

              <div className="named-area__body">
                <div className="a-card-stack">
                  
                  <div className="a-card a-card--normal">
                    <div className="a-card__paddings">
                      <LoadingSpinner statusText="Loading Purchase Order"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>

    )
  }


  return(
    <>
      <PageHeader stripeBackground='#fbe194' helpLink="ecwid/update-purchase-order-shipments-2/" />

      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Purchase Order Shipments</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">
                
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { (!shipments || shipments.length === 0) &&
                      <div className="a-card a-card--info a-card--info-blue">
                        <div className="a-card__paddings text-center">
                          <p>No shipments created yet for this purchase order. Create shipments to see and manage them here.</p>
                          <button className="btn btn-primary" onClick={() => addShipment()}>New Shipment</button>
                        </div>
                      </div>
                    }


                    { (shipments && shipments.length > 0) &&
                      <>
                        <div className="flex-table">
                          <div className="flex-table__head">
                            <div className="flex-table__col flex-table__col--align-left">Shipping company</div>
                            <div className="flex-table__col flex-table__col--align-left">Tracking #</div>
                            <div className="flex-table__col flex-table__col--align-left">Taxes and duties</div>
                            <div className="flex-table__col flex-table__col--align-left">Document ID</div>
                            <div className="flex-table__col flex-table__col--align-left">Actions</div>
                          </div>
                          { shipments.map(shipment =>
                            <div className="flex-table__row">
                              <div className="flex-table__col flex-table__col--align-left">{shipment.company_name}</div>
                              <div className="flex-table__col flex-table__col--align-left">{shipment.tracking}</div>
                              <div className="flex-table__col flex-table__col--align-left">{shipment.taxes}</div>
                              <div className="flex-table__col flex-table__col--align-left">{shipment.other}</div>
                              <div className="flex-table__col flex-table__col--align-left">
                                <span className="left-15 bottom-15"><button className="btn btn-default" onClick={() => updateDialog(shipment.id)}>Edit</button></span>
                                <span className="left-15 bottom-15"><button className="btn btn-delete" onClick={() => deleteDialog(shipment.id)}>Delete</button></span>
                              </div>
                            </div>
                          )}
                        </div>
                        <button className="btn btn-primary" onClick={() => addShipment()}>New Shipment</button>
                      </>
                    }

                  </div>
                </div>


              </div>
            </div>

          </div>



        </div>
      </div>



      { showAddShipmentModal && 
        <AddShipmentModal
          payload={payload}
          showAddShipmentModal={showAddShipmentModal}
          setShowAddShipmentModal={setShowAddShipmentModal}
          postUpdate={postUpdate}
          shipments={shipments}
          setShipments={setShipments}
          purchaseOrderId={id}
        />
      }

      { showUpdateShipmentModal && 
        <UpdateShipmentModal
          payload={payload}
          showUpdateShipmentModal={showUpdateShipmentModal}
          setShowUpdateShipmentModal={setShowUpdateShipmentModal}
          shipment={activeShipment}
          postUpdate={postUpdate}
          shipments={shipments}
          setShipments={setShipments}
          purchaseOrderId={id}
        />
      }

      { showDeleteShipmentModal &&
        <DeleteShipmentModal
          payload={payload}
          showDeleteShipmentModal={showDeleteShipmentModal}
          setShowDeleteShipmentModal={setShowDeleteShipmentModal}
          shipment={activeShipment}
          postUpdate={postUpdate}
          shipments={shipments}
          setShipments={setShipments}
          purchaseOrderId={id}
        />
      }
    </>
  )
}

const mapStateToProps = state => ({
  purchaseOrders: state.purchaseOrders,
});

const mapDispatchToProps = (dispatch) => ({
  loadPurchaseOrder: (payload, id) => dispatch(findPurchaseOrder(payload, id, null)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateShipments);